module.exports = __webpack_public_path__ + "ce9f9675ab711ca5451f3e5b2fa6e3a3.svg";